import { render, staticRenderFns } from "./renzhengTable.vue?vue&type=template&id=32b09f06&scoped=true&"
import script from "./renzhengTable.vue?vue&type=script&lang=js&"
export * from "./renzhengTable.vue?vue&type=script&lang=js&"
import style0 from "./renzhengTable.vue?vue&type=style&index=0&id=32b09f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b09f06",
  null
  
)

export default component.exports